/**
 * Polyfill for Promise.withResolvers
 * This is needed for PDF.js 4.8.69 which requires Promise.withResolvers
 */

// @ts-ignore - Ignore TypeScript errors for this polyfill
if (typeof Promise.withResolvers !== 'function') {
  // @ts-ignore - Ignore TypeScript errors for this polyfill
  Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
} 